import PaginationNumbers from "./pagination/PaginationNumbers";
import PaginationToFirst from "./pagination/PaginationToFirst";
import PaginationToLast from "./pagination/PaginationToLast";
import PaginationToNext from "./pagination/PaginationToNext";
import PaginationToPrev from "./pagination/PaginationToPrev";

const Pagination = ({
  offsetCount,
  setOffsetCount,
  paginationData,
  maxCount = 20,
}) => {
  const scrollAfterPagination = (e) => {
    const parent = e.currentTarget.parentElement.parentElement;
    const rect = parent.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    window.scrollTo({
      top: rect.top + scrollTop,
    });
  };

  const moveToFirst = (e) => {
    setOffsetCount(0);
    scrollAfterPagination(e)
  };

  const prevPage = (e) => {
    if (paginationData.has_prev_page) {
      setOffsetCount(offsetCount - 20);
      scrollAfterPagination(e);
    }
  };

  const nextPage = (e) => {
    if (paginationData.has_next_page) {
      setOffsetCount(offsetCount + 20);
      scrollAfterPagination(e);
    }
  };

  const moveToLast = (e) => {
    setOffsetCount((paginationData.page_count - 1) * maxCount)
    scrollAfterPagination(e)
  };

  if (paginationData && paginationData.total_count > maxCount) {
    return (
      <div className="pagination">
        <PaginationToFirst paginationData={paginationData} moveToFirst={moveToFirst} />
        <PaginationToPrev paginationData={paginationData} prevPage={prevPage} />
        <PaginationNumbers paginationData={paginationData} maxCount={maxCount} offsetCount={offsetCount} setOffsetCount={setOffsetCount} />
        <PaginationToNext paginationData={paginationData} moveNext={nextPage} />
        <PaginationToLast paginationData={paginationData} moveToLast={moveToLast} />
      </div>
    );
  } else return null;
};

export default Pagination;
